import IconMdi from '@components/IconMdi';
import { mdiAlert } from '@mdi/js';

export const isUserNotExists = (message?: string) => message === 'User does not exist.';

export const UserNotExistsBanner = () => (
  <div className="bg-error-50 mb-3 flex w-full items-start gap-4 rounded-md p-4">
    <IconMdi centerVertical={false} path={mdiAlert} className={'text-error-500'} />
    <div className="text-error-800 flex flex-col gap-2">
      <div className="flex items-center gap-3 text-sm leading-tight font-medium">
        User account does not exist. Please contact an administrator.
      </div>
    </div>
  </div>
);
